import { assetsApi } from './assets';

export type UploadPurpose = 'avatar' | 'project-cover' | 'resume' | 'hero-portrait';

export interface UploadResult {
  readonly url: string;
  readonly assetId: string;
}

export async function uploadFile(file: File, _purpose: UploadPurpose): Promise<UploadResult> {
  const asset = await assetsApi.upload(file);
  return { url: asset.url, assetId: asset.id };
}
